<template lang="pug">
  .gl-settings
    // nav
    gl-nav

    // page
    .gl-settings__page.gl-layout--medium-width(layout="row")

      // sidenav
      gl-settings-sidenav

      // content
      .gl-settings__page__content(flex)

        // head
        .gl-settings__head
          .gl-settings__head__context App Settings
          .gl-settings__head__title General

        // site settings
        .gl-layout__segment(layout="column" layout-gt-md="row")
          .gl-layout__segment__meta
            .gl-layout__segment__title Site Settings
            .gl-layout__segment__description Set the name of the site and in a few words, explain what this site is about.
          .gl-layout__segment__content(flex)
            // site settings: form
            b-form.gl-card.gl-card--form(@submit.prevent="submitSiteForm" novalidate)
              // body
              .gl-card--form__body
                gl-alert(
                  :options="{ errorList: site.errorList }"
                  @clear-error-list="site.errorList = []")
                b-form-group(:state="site.form.name.state" label="Name of Site" label-for="siteName")
                  b-form-input(
                    :state="site.form.name.state"
                    v-model.trim="site.form.name.val"
                    v-gl-focus="true"
                    required
                    id="siteName"
                    type="text"
                    placeholder="E.g. My Agency Analytics"
                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
                  .invalid-feedback(v-if="site.form.name.invalidFeedback") {{ site.form.name.invalidFeedback }}
                b-form-group(:state="site.form.tagline.state" label="Tagline" label-for="tagline")
                  b-form-input(
                    :state="site.form.tagline.state"
                    v-model.trim="site.form.tagline.val"
                    required
                    id="tagline"
                    type="text"
                    placeholder="E.g. Custom dashboards for clients of My Agency"
                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
                  .invalid-feedback(v-if="site.form.tagline.invalidFeedback") {{ site.form.tagline.invalidFeedback }}
              // footer
              .gl-card--form__footer(layout="row" layout-align="end start")
                gl-btn(:options="{ label: 'Save changes', type: 'submit', style: 'brand-settings', isLoading: site.isLoading.save }")

        // divider
        .gl-layout__divider

        // page titles
        .gl-layout__segment(layout="column" layout-gt-md="row")
          .gl-layout__segment__meta
            .gl-layout__segment__title Page Titles
            .gl-layout__segment__description Set page titles for various pages in the application.
          .gl-layout__segment__content(flex)
            // page titles: form
            b-form.gl-card.gl-card--form(@submit.prevent="submitTitleForm" novalidate)
              // body
              .gl-card--form__body
                gl-alert(
                  :options="{ errorList: titles.errorList }"
                  @clear-error-list="titles.errorList = []")
                b-form-group(:state="titles.form.login.state" label="Login Page Title" label-for="login")
                  b-form-input(
                    :state="titles.form.login.state"
                    v-model.trim="titles.form.login.val"
                    required
                    id="login"
                    type="text"
                    placeholder="Login"
                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
                  .invalid-feedback(v-if="titles.form.login.invalidFeedback") {{ titles.form.login.invalidFeedback }}
                b-form-group(:state="titles.form.dashboard.state" label="Dashboard Page Title" label-for="dashboard")
                  b-form-input(
                    :state="titles.form.dashboard.state"
                    v-model.trim="titles.form.dashboard.val"
                    required
                    id="dashboard"
                    type="text"
                    placeholder="Dashboard"
                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
                  .invalid-feedback(v-if="titles.form.dashboard.invalidFeedback") {{ titles.form.dashboard.invalidFeedback }}
              // footer
              .gl-card--form__footer(layout="row" layout-align="end start")
                gl-btn(:options="{ label: 'Save changes', type: 'submit', style: 'brand-settings', isLoading: titles.isLoading.save }")

        // divider
        .gl-layout__divider(v-gl-superadmin-only="true")

        // periscope integration
        .gl-layout__segment(v-gl-superadmin-only="true" layout="column" layout-gt-md="row")
          .gl-layout__segment__meta
            .gl-layout__segment__title Periscope Integration
            .gl-layout__segment__description
              span.pr-4 You can find this information under
              b.pr-4 Settings &gt; Billing &amp; Authentication
              span within your periscope account.

          .gl-layout__segment__content(flex)

            // periscope integration: form
            b-form.gl-card.gl-card--form(@submit.prevent="submitPeriscopeForm" novalidate)
              // body
              .gl-card--form__body
                gl-alert(
                  :options="{ errorList: periscope.errorList }"
                  @clear-error-list="periscope.errorList = []")
                b-form-group(:state="periscope.form.apiKey.state" label="API Key" label-for="apiKey")
                  b-form-input(
                    :state="periscope.form.apiKey.state"
                    v-model.trim="periscope.form.apiKey.val"
                    required
                    id="apiKey"
                    type="text"
                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
                  .invalid-feedback(v-if="periscope.form.apiKey.invalidFeedback") {{ periscope.form.apiKey.invalidFeedback }}
              // footer
              .gl-card--form__footer(layout="row" layout-align="end start")
                gl-btn(:options="{ label: 'Save changes', type: 'submit', style: 'brand-settings', isLoading: periscope.isLoading.save }")

        // divider
        .gl-layout__divider(v-gl-superadmin-only="true")

        // mode integration
        .gl-layout__segment(v-gl-superadmin-only="true" layout="column" layout-gt-md="row")
          .gl-layout__segment__meta
            .gl-layout__segment__title Mode Integration
            .gl-layout__segment__description You can find this information within your mode account.

          .gl-layout__segment__content(flex)

            // mode integration: form
            b-form.gl-card.gl-card--form(@submit.prevent="submitModeForm" novalidate)
              // body
              .gl-card--form__body
                gl-alert(:options="{ errorList: mode.errorList }" @clear-error-list="mode.errorList = []")
                // organization
                b-form-group(:state="mode.form.organization.state" label="Organization Name" label-for="input--organization")
                  b-form-input(
                    :state="mode.form.organization.state"
                    v-model.trim="mode.form.organization.val"
                    required
                    id="input--organization"
                    type="text")
                  .invalid-feedback(v-if="mode.form.organization.invalidFeedback") {{ mode.form.organization.invalidFeedback }}

                // apiToken
                b-form-group(:state="mode.form.apiToken.state" label="API Token" label-for="input--api-token")
                  b-form-input(
                    :state="mode.form.apiToken.state"
                    v-model.trim="mode.form.apiToken.val"
                    required
                    id="input--api-token"
                    type="text")
                  .invalid-feedback(v-if="mode.form.apiToken.invalidFeedback") {{ mode.form.apiToken.invalidFeedback }}

                // apiPassword
                b-form-group(:state="mode.form.apiPassword.state" label="API Token Password" label-for="input--api-password")
                  b-form-input(
                    :state="mode.form.apiPassword.state"
                    v-model.trim="mode.form.apiPassword.val"
                    required
                    id="input--api-password"
                    type="password")
                  .invalid-feedback(v-if="mode.form.apiPassword.invalidFeedback") {{ mode.form.apiPassword.invalidFeedback }}

                // embedToken
                b-form-group(:state="mode.form.embedToken.state" label="Embed Access Key" label-for="input--embed-token")
                  b-form-input(
                    :state="mode.form.embedToken.state"
                    v-model.trim="mode.form.embedToken.val"
                    required
                    id="input--embed-token"
                    type="text")
                  .invalid-feedback(v-if="mode.form.embedToken.invalidFeedback") {{ mode.form.embedToken.invalidFeedback }}

                // embedSecret
                b-form-group(:state="mode.form.embedSecret.state" label="Embed Access Secret" label-for="input--embed-secret")
                  b-form-input(
                    :state="mode.form.embedSecret.state"
                    v-model.trim="mode.form.embedSecret.val"
                    required
                    id="input--embed-secret"
                    type="password")
                  .invalid-feedback(v-if="mode.form.embedSecret.invalidFeedback") {{ mode.form.embedSecret.invalidFeedback }}

              // footer
              .gl-card--form__footer(layout="row" layout-align="end start")
                gl-btn(:options="{ label: 'Save changes', type: 'submit', style: 'brand-settings', isLoading: mode.isLoading.save }")

</template>

<script>
import { mapGetters } from 'vuex'

export default {

  // data
  data () {
    return {
      site: {
        errorList: [],
        form: {
          name: { val: '', state: null, invalidFeedback: '' },
          tagline: { val: '', state: null, invalidFeedback: '' }
        },
        isLoading: {
          save: false
        }
      },
      titles: {
        errorList: [],
        form: {
          login: { val: '', state: null, invalidFeedback: '' },
          dashboard: { val: '', state: null, invalidFeedback: '' }
        },
        isLoading: {
          save: false
        }
      },
      periscope: {
        errorList: [],
        form: {
          apiKey: { val: '', state: null, invalidFeedback: '' }
        },
        isLoading: {
          save: false
        }
      },
      mode: {
        errorList: [],
        form: {
          organization: { val: '', state: null, invalidFeedback: '' },
          apiToken: { val: '', state: null, invalidFeedback: '' },
          apiPassword: { val: '', state: null, invalidFeedback: '' },
          embedToken: { val: '', state: null, invalidFeedback: '' },
          embedSecret: { val: '', state: null, invalidFeedback: '' }
        },
        isLoading: {
          save: false
        }
      }
    }
  },

  // computed
  computed: {
    ...mapGetters(['config'])
  },

  // mounted
  mounted () {
    // bind form w/ config
    this.bindForm(this.config)
  },

  // watch
  watch: {
    // on config update -> bindForm
    config: function (config) {
      this.bindForm(config)
    }
  },

  // methods
  methods: {
    bindForm (config) {
      // bind site.form
      this.site.form.name.val = config.agency.name
      this.site.form.tagline.val = config.agency.tagline

      // bind periscope.form
      this.periscope.form.apiKey.val = config.agency.periscopeApiKey

      // bind titles.form
      this.titles.form.login.val = config.agency.ptLogin
      this.titles.form.dashboard.val = config.agency.ptDashboard

      // bind mode.form
      this.mode.form.organization.val = config.agency.modeOrganization
      this.mode.form.embedToken.val = config.agency.modeEmbedToken
      this.mode.form.embedSecret.val = config.agency.modeEmbedSecret
      this.mode.form.apiToken.val = config.agency.modeApiToken
      this.mode.form.apiPassword.val = config.agency.modeApiPassword
    },
    submitSiteForm () {
      // clear previous errors
      this.site.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.site.form)

      // if form is valid
      if (this.validateSiteForm()) {
        // start loading
        this.site.isLoading.save = true

        // build config request
        const CONFIG_REQUEST = {
          agency: { name: this.site.form.name.val, tagline: this.site.form.tagline.val }
        }

        // upsert config
        return this.$glAuth.upsertConfig(CONFIG_REQUEST)
          .then(() => {
            // show success notification
            this.$toasted.show('General settings saved!', {
              theme: 'primary',
              type: 'success',
              position: 'top-center',
              duration: 5000
            })
          })
          .catch(e => {
            // push server error
            this.site.errorList.push(this.$glForm.parseError(e))
          })
          .finally(() => {
            // stop loading
            this.site.isLoading.save = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError({ el: this.$el })
      }
    },
    validateSiteForm () {
      // if no site.name -> invalid
      if (!this.site.form.name.val) {
        this.site.form.name.state = 'invalid'
        this.site.form.name.invalidFeedback = 'A site name is required'
      }
      // if no site.tagline -> invalid
      if (!this.site.form.tagline.val) {
        this.site.form.tagline.state = 'invalid'
        this.site.form.tagline.invalidFeedback = 'A tagline is required'
      }

      // return true if no fields are invalid
      return this.$glForm.hasNoInvalid(this.site.form)
    },
    submitTitleForm () {
      // clear previous errors
      this.titles.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.titles.form)

      // start loading
      this.titles.isLoading.save = true

      // init deleteProps
      let deleteProps = []

      // init upsertRequest
      let upsertRequest = { agency: {} }

      // init promises
      let promises = []

      // if login -> add login to upsert
      // else: no login -> add login to deleteProps
      if (this.titles.form.login.val) upsertRequest.agency.ptLogin = this.titles.form.login.val
      else deleteProps.push({ agency: true, prop: 'ptLogin' })

      // if dashboard -> add dashboard to upsert
      // else: no dashboard -> add dashboard to deleteProps
      if (this.titles.form.dashboard.val) upsertRequest.agency.ptDashboard = this.titles.form.dashboard.val
      else deleteProps.push({ agency: true, prop: 'ptDashboard' })

      // if upsertRequest has login or dashboard -> upsert
      if (upsertRequest.agency.ptLogin || upsertRequest.agency.ptDashboard) {
        promises.push(this.$glAuth.upsertConfig(upsertRequest))
      }

      // if deleteProps has login or dashboard -> delete props
      if (deleteProps.length) {
        promises.push(this.$glAuth.deleteConfig(deleteProps))
      }

      return Promise.all(promises)
        .then(() => {
          // show success notification
          this.$toasted.show('Page titles saved', {
            theme: 'primary',
            type: 'success',
            position: 'top-center',
            duration: 5000
          })
        })
        .catch(e => {
          // push server error
          this.titles.errorList.push(this.$glForm.parseError(e))
        })
        .finally(() => {
          // stop loading
          this.titles.isLoading.save = false
        })
    },
    submitPeriscopeForm () {
      // clear previous errors
      this.periscope.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.periscope.form)

      // if form is valid
      if (this.validatePeriscopeForm()) {
        // start loading
        this.periscope.isLoading.save = true

        // build config request
        const CONFIG_REQUEST = { agency: { periscopeApiKey: this.periscope.form.apiKey.val } }

        // upsert config
        return this.$glAuth.upsertConfig(CONFIG_REQUEST)
          .then(() => {
            // show success notification
            this.$toasted.show('Periscope settings saved!', {
              theme: 'primary',
              type: 'success',
              position: 'top-center',
              duration: 5000
            })
          })
          .catch(e => {
            // push server error
            this.periscope.errorList.push(this.$glForm.parseError(e))
          })
          .finally(() => {
            // stop loading
            this.periscope.isLoading.save = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError(this.$el)
      }
    },
    validatePeriscopeForm () {
      // if no periscope.apiKey -> invalid
      if (!this.periscope.form.apiKey.val) {
        this.periscope.form.apiKey.state = 'invalid'
        this.periscope.form.apiKey.invalidFeedback = 'An api key is required'
      }

      // return true if no fields are invalid
      return this.$glForm.hasNoInvalid(this.periscope.form)
    },
    submitModeForm () {
      // clear previous errors
      this.mode.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.mode.form)

      // if form is valid
      if (this.validateModeForm()) {
        // start loading
        this.mode.isLoading.save = true

        // build config request
        const CONFIG_REQUEST = { agency: {
          modeOrganization: this.mode.form.organization.val,
          modeApiToken: this.mode.form.apiToken.val,
          modeApiPassword: this.mode.form.apiPassword.val,
          modeEmbedToken: this.mode.form.embedToken.val,
          modeEmbedSecret: this.mode.form.embedSecret.val
        } }

        // upsert config
        return this.$glAuth.upsertConfig(CONFIG_REQUEST)
          // on success => get mode reports
          .then(() => {
            return this.$glHttp.post('mode/fetch-reports')
          })
          // on success => show success toast
          .then(() => {
            this.$toasted.show('Mode settings saved!', {
              theme: 'primary',
              type: 'success',
              position: 'top-center',
              duration: 5000
            })
          })
          // on error => show server error
          .catch(e => {
            this.mode.errorList.push(this.$glForm.parseError(e))
          })
          // on finally => stop loading
          .finally(() => {
            this.mode.isLoading.save = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError(this.$el)
      }
    },
    validateModeForm () {
      // if no mode.organization -> invalid
      if (!this.mode.form.organization.val) {
        this.mode.form.organization.state = 'invalid'
        this.mode.form.organization.invalidFeedback = 'An organization name is required'
      }
      // if no mode.apiToken -> invalid
      if (!this.mode.form.apiToken.val) {
        this.mode.form.apiToken.state = 'invalid'
        this.mode.form.apiToken.invalidFeedback = 'An api token is required'
      }
      // if no mode.apiPassword -> invalid
      if (!this.mode.form.apiPassword.val) {
        this.mode.form.apiPassword.state = 'invalid'
        this.mode.form.apiPassword.invalidFeedback = 'An token password is required'
      }
      // if no mode.embedToken -> invalid
      if (!this.mode.form.embedToken.val) {
        this.mode.form.embedToken.state = 'invalid'
        this.mode.form.embedToken.invalidFeedback = 'An embed key is required'
      }
      // if no mode.embedSecret -> invalid
      if (!this.mode.form.embedSecret.val) {
        this.mode.form.embedSecret.state = 'invalid'
        this.mode.form.embedSecret.invalidFeedback = 'An embed secret is required'
      }

      // return true if no fields are invalid
      return this.$glForm.hasNoInvalid(this.mode.form)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/SettingsGeneral.vue